(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pp-mobile-refinements"]) return;
  try {
    
(()=>{
function setup(){
 const settings=document.querySelector('[data-pp-mobile-refinements]');
 if(!settings)return;
 const root=document.querySelector('[data-product-root]');
 if(!root||root.dataset.ppBundleLabels)return;
 root.dataset.ppBundleLabels='true';
 const labels={'Single Bale':settings.dataset.single,'Duo':settings.dataset.duo,'Trio':settings.dataset.trio};
 function update(){
  root.querySelectorAll('.kaching-bundles__block-title').forEach(el=>{if(el.textContent.trim()==='ONLINE BUNLDES'||el.textContent.trim()==='ONLINE BUNDLES')el.textContent=settings.dataset.heading;});
  root.querySelectorAll('.kaching-bundles__bar-title').forEach(el=>{const value=labels[el.textContent.trim()];if(value)el.textContent=value;});
 }
 update();new MutationObserver(update).observe(root,{subtree:true,childList:true,characterData:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();
})();
